import { PURCHASE_ERROR_CODES_TEXT, DEPENDS_ON_REALM, PURCHASE_ERROR_CODES_TEXT_FOR_CIS } from '../constants/purchaseErrorCodes.js';

function getPurchaseErrorCodeText(errorCode, isCISReam) {
    if (!PURCHASE_ERROR_CODES_TEXT.hasOwnProperty(errorCode)) {
        return null;
    }
    if (!DEPENDS_ON_REALM.includes(errorCode)) {
        return PURCHASE_ERROR_CODES_TEXT[errorCode];
    }
    return isCISReam ? PURCHASE_ERROR_CODES_TEXT_FOR_CIS[errorCode] : PURCHASE_ERROR_CODES_TEXT[errorCode];
}

export { getPurchaseErrorCodeText as default };
//# sourceMappingURL=errorsText.js.map
